import { Injectable, Type, ViewContainerRef } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root',
})
export class SidenavDrawerService {
  static close() {
    throw new Error('Method not implemented.');
  }

  private drawer!: MatDrawer;
  private container!: ViewContainerRef;
  private loadComponentFn!: <T extends object>(
    component: Type<T>,
    data?: Partial<T>
  ) => void;

  setDrawer(
    drawer: MatDrawer,
    container: ViewContainerRef,
    loadComponentFn: <T extends object>(
      component: Type<T>,
      data?: Partial<T>
    ) => void
  ) {
    this.drawer = drawer;
    this.container = container;
    this.loadComponentFn = loadComponentFn;
  }

  async open<T extends object>(
    input:
      | Type<T>
      | { component: Type<T>; data?: Partial<T> }
      | { component: Type<T>; data?: Partial<T> }[]
  ): Promise<void> {
    if (this.drawer && this.container && this.loadComponentFn) {
      try {
        this.container.clear();
        if (typeof input === 'function') {
          this.loadComponentFn(input);
        } else if (!Array.isArray(input) && input.component) {
          this.loadComponentFn(input.component, input.data);
        } else if (Array.isArray(input)) {
          for (const { component, data } of input) {
            this.loadComponentFn(component, data);
          }
        }
        await this.drawer.open();
      } catch (error) {
        console.error('Error opening drawer:', error);
      }
    }
  }

  async close(): Promise<void> {
    if (this.drawer) {
      try {
        await this.drawer.close();
      } catch (error) {
        console.error(error);
      }
    }
  }
}
